import React from 'react';

import { ConfirmButton, FloatingContainer } from './styles';

export interface Props {
  children: string;
  isEdit: boolean;
  dirty: boolean;
  loading?: boolean;
}

const FloatingSubmitButton = ({ children, isEdit, dirty, loading }: Props) => {
  if (!isEdit || dirty) {
    return (
      <FloatingContainer fixed={isEdit}>
        <ConfirmButton type="submit" value={children} loading={loading} disabled={loading} />
      </FloatingContainer>
    );
  } else return null;
};

export default FloatingSubmitButton;
